import { create } from 'zustand'
import { Keyboard, Platform } from 'react-native'

type KeyboardStore = {
    isKeyboardOpen: boolean
    initializeKeyboardListener: () => void | (() => void)
}

export const useKeyboardStore = create<KeyboardStore>((set) => ({
    isKeyboardOpen: false,

    initializeKeyboardListener: () => {
        if (Platform.OS === 'web') {
            return
        }

        const showEvent =
            Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow'
        const hideEvent =
            Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide'

        const subShow = Keyboard.addListener(showEvent, () => {
            set({ isKeyboardOpen: true })
        })

        const subHide = Keyboard.addListener(hideEvent, () => {
            set({ isKeyboardOpen: false })
        })

        // devolvemos cleanup
        return () => {
            subShow.remove()
            subHide.remove()
        }
    },
}))
